import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { BrainCircuitIcon, SparklesIcon, TargetIcon } from 'lucide-react';
export function MetodoSection() {
  const [ref, isInView] = useInView({
    threshold: 0.15
  });
  const columns = [{
    title: 'Claridad Interior',
    text: 'Identificas patrones invisibles que afectan cómo piensas, decides y actúas frente a tus oportunidades, hábitos y dirección personal.',
    highlight: 'Aquí ocurre el cambio real.',
    icon: <BrainCircuitIcon className="w-16 h-16 text-[#D4AF37] mx-auto group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]" data-id="element-348" />
  }, {
    title: 'Orden y claridad mental',
    text: 'Tu mente deja de estar saturada. Empiezas a pensar con claridad, reducir el ruido interno y ver oportunidades que antes pasaban desapercibidas.',
    icon: <SparklesIcon className="w-16 h-16 text-[#D4AF37] mx-auto group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]" data-id="element-349" />
  }, {
    title: 'Acción dirigida',
    text: 'No se trata solo de pensar distinto. Empiezas a actuar con dirección, sostener mejores decisiones y crear cambios visibles en tu día a día.',
    icon: <TargetIcon className="w-16 h-16 text-[#D4AF37] mx-auto group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]" data-id="element-350" />
  }];
  return <section id="como-funciona" className="py-16 sm:py-32 relative overflow-hidden bg-[#0A0A0B] border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-351">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_60%)] pointer-events-none" data-id="element-352" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-353">
        <div className="text-center mb-16 sm:mb-24" data-id="element-354">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white" data-id="element-355">
            Tres pasos para observar{' '}
            <span className="text-gold" data-id="element-356">con más claridad</span>
          </motion.h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-357">
          {columns.map((col, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group bg-[#0c0c0e] border border-gold/20 p-8 sm:p-10 rounded-2xl hover:-translate-y-2 hover:shadow-[0_15px_40px_rgba(212,175,55,0.15)] hover:border-gold/40 transition-all duration-300 flex flex-col text-center" data-id="element-358">
              <div className="mb-8 flex justify-center" data-id="element-359">{col.icon}</div>
              <h3 className="font-serif text-xl sm:text-2xl font-bold text-gold mb-4" data-id="element-360">
                {col.title}
              </h3>
              <p className="text-white/80 text-base sm:text-lg leading-relaxed flex-grow" data-id="element-361">
                {col.text}
              </p>
              {col.highlight && <p className="text-white font-bold mt-6 pt-6 border-t border-white/10" data-id="element-362">
                  {col.highlight}
                </p>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}